import { TextV2 } from '@insights-ltd/design-library/components';
import { Button, ListItem, ListItemText } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import { Practitioner } from './EventForms';

type ListByFullNameProps<T> = {
  items: T[];
  itemSpacing?: number;
  showRemove: (practitioner: T) => boolean;
  onRemove?: (practitioner: T) => void;
};

export const ListByFullName = <T extends Practitioner>({
  items,
  itemSpacing = 2,
  showRemove = () => true,
  onRemove,
}: ListByFullNameProps<T>) => {
  const { t } = useTranslation();
  return [
    ...items.map((practitioner) => {
      return (
        <ListItem
          key={practitioner.id}
          sx={(theme) => ({
            borderLeft: `1px solid ${theme.palette.grey[500]}`,
            borderRight: `1px solid ${theme.palette.grey[500]}`,
            borderBottom: `1px solid ${theme.palette.grey[500]}`,
            backgroundColor: theme.palette.grey[100],
            '&:first-of-type': {
              border: `1px solid ${theme.palette.grey[500]}`,
              borderTopLeftRadius: '4px',
              borderTopRightRadius: '4px',
              marginTop: itemSpacing,
            },
            '&:last-of-type': {
              borderBottomLeftRadius: '4px',
              borderBottomRightRadius: '4px',
            },
          })}
        >
          <Grid container wrap="nowrap" sx={{ display: 'flex' }}>
            <Grid sx={{ flexGrow: 1, minWidth: 0 }} size={8}>
              <ListItemText>{practitioner.fullName}</ListItemText>
              <TextV2 variant="bodySmall">{practitioner.emailAddress}</TextV2>
            </Grid>
            {items.length > 1 && (
              <Grid
                size={3}
                sx={{
                  alignContent: 'center',
                  flexGrow: 1,
                  minWidth: 0,
                }}
              >
                {showRemove(practitioner) && (
                  <Button
                    variant="text"
                    color="error"
                    sx={{ padding: '0px', minWidth: '100px' }}
                    onClick={
                      onRemove ? () => onRemove(practitioner) : undefined
                    }
                  >
                    {t(
                      'ui.event-management.organisation.practitioners.list.remove-button',
                    )}
                  </Button>
                )}
              </Grid>
            )}
          </Grid>
        </ListItem>
      );
    }),
  ];
};
